import React from "react";
import InputText from "./input-text";
import InputDropdown from "./input-dropdown";
import store from "src/store";
import InputTextarea from "./input-textarea";
import { closeIcon, successIcon, synchronizeIcon } from "./icons-svg";
import useIsLoggedIn from "src/utils/use-is-logged-in";

export default function MyReviewForm(props) {
    const { userInfo } = useIsLoggedIn();

    const getUserEngagementList = () => {
        if (store.userEngagements.length) {
            return store.userEngagements.map((item) => {
                if(!userInfo?.auth0Subscripton && item.organizationData) {
                    return {
                        label: item.organizationData.name +' / '+item.engId,
                        value: item.engId
                    }
                } else {
                    return {
                        label: item.engId,
                        value: item.engId
                    }
                }
            });
        } else {
            return [];
        }
    }

    return (
        <>
            <form>
                <div css="margin-top: 15px;">
                    <InputDropdown
                        id={"engagementId"}
                        label={"Engagement Id"}
                        value={props.newEngagementId}
                        disabled={false}
                        showClearOption={false}
                        showOutsideLabel = {true}
                        onChange={(value) => { props.onEngagementIdChange(value) }}
                        list={getUserEngagementList()}
                        hasError={props.newEngagementIdHasError}
                        errorText={props.newEngagementIdErrorText}
                    />
                </div>
                <div>
                    {props.saveMessage === 'validating' && (
                        <span
                        > {synchronizeIcon} Checking Availability of the engagement...</span>
                    )}
                    {props.saveMessage === 'available' && (
                        <span
                        > {successIcon} You are allowed to create {props.allowedVersions} more version for this engagement</span>
                    )}
                    {props.saveMessage === 'notAvailable' && (
                        <span
                        > {closeIcon} Engagement is not available or error on fetching data</span>
                    )}
                </div>
                <div css="margin-top: 15px;">
                    <InputText
                        id={"reviewName"}
                        label={"Version Name"}
                        value={props.newReviewName}
                        onChange={(value) => { props.onReviewNameChange(value) }}
                        hasError={props.newReviewNameHasError}
                        errorText={props.newReviewNameErrorText}
                    />
                </div>
                <div css="margin-top: 15px;">
                    <InputTextarea
                        id={"newReviewDescription"}
                        label={"Description"}
                        rows={4}
                        value={props.newReviewDescription}
                        onChange={(value) => { props.onReviewDescriptionChange(value) }} />
                </div>
            </form>
        </>
    )
}